import { render } from "./ViewBlog.vue?vue&type=template&id=34902b6e"
import script from "./ViewBlog.vue?vue&type=script&lang=js"
export * from "./ViewBlog.vue?vue&type=script&lang=js"

import "./ViewBlog.vue?vue&type=style&index=0&id=34902b6e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__